import {
  buildSlackMessage,
  FEEDBACK_CATEGORIES,
  FeedbackCategory,
  sendSlackFeedback,
} from 'lib/feedback';
import { ClientUser } from '@/types';

/** フィードバックを Slack に送信する。カテゴリ・内容・送信者プロフィールから整形する。 */
export const submitFeedback = async (
  category: FeedbackCategory,
  content: string,
  profile: ClientUser | undefined,
): Promise<void> => {
  const cat = FEEDBACK_CATEGORIES.find((c) => c.value === category);
  const message = buildSlackMessage({
    heading: cat ? `${cat.emoji} ${cat.label}` : category,
    appLabel: `Client (${import.meta.env.VITE_APP_ENV ?? '-'})`,
    color: cat?.color ?? '#868686',
    content,
    fields: [
      { label: '名前', value: profile?.name },
      { label: 'メール', value: profile?.email },
      { label: 'ユーザー名', value: profile?.username },
    ],
    contextItems: [
      `🕒 ${new Date().toISOString()}`,
      `📐 ${window.innerWidth}×${window.innerHeight}`,
      navigator.userAgent,
    ],
  });
  await sendSlackFeedback(import.meta.env.VITE_SLACK_WEBHOOK_URL, message);
};
